var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlotsm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53846 9.15385C7.53846 11.2356 5.85095 12.9231 3.76923 12.9231C1.68751 12.9231 0 11.2356 0 9.15385C0 7.07213 1.68751 5.38462 3.76923 5.38462C5.85095 5.38462 7.53846 7.07213 7.53846 9.15385Z",
    fill: "#E72649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2308 6.46153C9.45759 6.46153 8.73919 6.69627 8.14162 7.09578C8.43669 7.72258 8.61541 8.41501 8.61541 9.15384C8.61541 10.4612 8.09196 11.6427 7.25098 12.5138C7.94015 13.412 9.01168 14 10.2308 14C12.3125 14 14 12.3125 14 10.2308C14 8.14907 12.3125 6.46157 10.2308 6.46157V6.46153Z",
    fill: "#E72649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23058 4.30769H4.30751C4.30751 3.01538 3.72385 1.86742 2.81917 1.07692H3.76905C6.47434 1.07692 8.75735 2.90228 9.46289 5.38462H10.5732C9.84077 2.30246 7.072 0 3.76923 0H0V1.07692C1.78126 1.07692 3.23077 2.52643 3.23077 4.30769H3.23058Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotsm);
export default __webpack_public_path__ + "static/media/slotsm.ef80bc5573a316b5d55a3835255d0cee.svg";
export { ForwardRef as ReactComponent };